export const GameIdsMap = {
  DOTA: 7314,
  LOL: 5426,
  FORTNITE: 21216,
  RS6: 10826,
  PUBG: 10906,
  SPLITGATE: 21404,
  VALORANT: 21640,
  APEX: 21566,
  CALL_OF_DUTY: 27860,
  ROCKET_LEAGUE: 10798,
  LOL_TFT: 5426111,
  HEARTHSTONE: 9898,
  OVERWATCH: 10844,
  MINECRAFT_PC: 8032,
  HALO_INFINITE: 21854,
  FALL_GUYS: 42424,
  LEAP: 22312,
  LOL_ARENA: 21556,
  PALWORLD: 23944,
  MARVEL_RIVALS: 24890,
  STREET_FIGHTER_6: 22894,
  GENSHIN_IMPACT: 21656,
  REPO: 25448,
  CS2: 22730,
  ROBLOX: 4688,
  REMATCH: 26120,
  ROBLOX_MS: 22174,
  PEAK: 26092,
  ARC_RAIDERS: 27168,
}

export const gameIds = [
  GameIdsMap.DOTA,
  GameIdsMap.LOL,
  GameIdsMap.FORTNITE,
  GameIdsMap.RS6,
  GameIdsMap.PUBG,
  GameIdsMap.SPLITGATE,
  GameIdsMap.VALORANT,
  GameIdsMap.APEX,
  GameIdsMap.CALL_OF_DUTY,
  GameIdsMap.ROCKET_LEAGUE,
  GameIdsMap.LOL_TFT,
  GameIdsMap.HEARTHSTONE,
  GameIdsMap.OVERWATCH,
  GameIdsMap.MINECRAFT_PC,
  GameIdsMap.HALO_INFINITE,
  GameIdsMap.FALL_GUYS,
  GameIdsMap.LEAP,
  GameIdsMap.LOL_ARENA,
  GameIdsMap.PALWORLD,
  GameIdsMap.MARVEL_RIVALS,
  GameIdsMap.STREET_FIGHTER_6,
  GameIdsMap.GENSHIN_IMPACT,
  GameIdsMap.REPO,
  GameIdsMap.CS2,
  GameIdsMap.ROBLOX,
  GameIdsMap.REMATCH,
  GameIdsMap.ROBLOX_MS,
  GameIdsMap.PEAK,
  GameIdsMap.ARC_RAIDERS,
]

export const gameNamesDesktop: Record<number, string> = {
  [GameIdsMap.DOTA]: "Dota 2",
  [GameIdsMap.LOL]: "League Of Legends",
  [GameIdsMap.FORTNITE]: "Fortnite",
  [GameIdsMap.RS6]: "Rainbow Six: Siege",
  [GameIdsMap.PUBG]: "PUBG",
  [GameIdsMap.SPLITGATE]: "Splitgate",
  [GameIdsMap.VALORANT]: "Valorant",
  [GameIdsMap.APEX]: "APEX",
  [GameIdsMap.CALL_OF_DUTY]: "Call of Duty",
  [GameIdsMap.ROCKET_LEAGUE]: "Rocket League",
  [GameIdsMap.LOL_TFT]: "Teamfight Tactics",
  [GameIdsMap.HEARTHSTONE]: "Hearthstone",
  [GameIdsMap.OVERWATCH]: "Overwatch",
  [GameIdsMap.MINECRAFT_PC]: "Minecraft Desktop",
  [GameIdsMap.HALO_INFINITE]: "Halo Infinite",
  [GameIdsMap.FALL_GUYS]: "Fall Guys",
  [GameIdsMap.LEAP]: "LEAP",
  [GameIdsMap.LOL_ARENA]: "League of Legends Arena Mode",
  [GameIdsMap.PALWORLD]: "Palworld",
  [GameIdsMap.MARVEL_RIVALS]: "Marvel Rivals",
  [GameIdsMap.STREET_FIGHTER_6]: "Street Fighter 6",
  [GameIdsMap.GENSHIN_IMPACT]: "Genshin Impact",
  [GameIdsMap.REPO]: "R.E.P.O.",
  [GameIdsMap.CS2]: "Counter-Strike 2",
  [GameIdsMap.ROBLOX]: "Roblox",
  [GameIdsMap.REMATCH]: "Rematch",
  [GameIdsMap.ROBLOX_MS]: "Roblox Microsoft edition",
  [GameIdsMap.PEAK]: "PEAK",
  [GameIdsMap.ARC_RAIDERS]: "ARC Raiders",
}

export const gameNames: Record<number, string> = { ...gameNamesDesktop }

// Descending total avgDailyPlayerMatches across available GEO benchmarks.
// Source window: June 14-July 13, 2026 (Moments Builder benchmark dataset).
const GAME_IDS_BY_MATCH_POPULARITY = [
  GameIdsMap.ROBLOX,
  GameIdsMap.VALORANT,
  GameIdsMap.LOL,
  GameIdsMap.MINECRAFT_PC,
  GameIdsMap.FORTNITE,
  GameIdsMap.MARVEL_RIVALS,
  GameIdsMap.OVERWATCH,
  GameIdsMap.APEX,
  GameIdsMap.RS6,
  GameIdsMap.CS2,
  GameIdsMap.LOL_TFT,
  GameIdsMap.DOTA,
  GameIdsMap.ROCKET_LEAGUE,
  GameIdsMap.GENSHIN_IMPACT,
  GameIdsMap.PUBG,
  GameIdsMap.LOL_ARENA,
  GameIdsMap.HEARTHSTONE,
  GameIdsMap.CALL_OF_DUTY,
  GameIdsMap.REMATCH,
  GameIdsMap.PALWORLD,
  GameIdsMap.REPO,
  GameIdsMap.ARC_RAIDERS,
  GameIdsMap.FALL_GUYS,
  GameIdsMap.STREET_FIGHTER_6,
  GameIdsMap.PEAK,
  GameIdsMap.SPLITGATE,
] as const

const gamePopularityRank = new Map<number, number>(
  GAME_IDS_BY_MATCH_POPULARITY.map((gameId, index) => [gameId, index]),
)

export const GAMES_LABELS_LIST = Object.entries(gameNames)
  .map(([key, value]) => ({ label: value, value: Number(key) }))
  .sort((left, right) => {
    const popularityDifference = (gamePopularityRank.get(left.value) ?? Number.MAX_SAFE_INTEGER)
      - (gamePopularityRank.get(right.value) ?? Number.MAX_SAFE_INTEGER)

    return popularityDifference || left.label.localeCompare(right.label)
  })

// The map is partial: stored config may name a game this catalog no longer lists, and a blank cell
// would read as "no game" rather than one that is simply unnamed here.
export const getGameName = (gameId: number | string): string => gameNames[Number(gameId)] || String(gameId)
